import { Button } from "@material-ui/core";
import clsx from "clsx";
import { t } from "i18next";
import * as conf from "qpr-base/configuration";
import React, { useState } from "react";
import useFormStyles, { useButtonStyles } from "../KPIsForm/themes";
import { Milestones } from "../ProjectForm/index.dto";
import SubItemForm from "./SubItemForm";
import SubInfoList from "./SubItemList";

type Props = {
  isMilestone?: boolean;
  currentList: Milestones[] | any;
  periodlevelId: string;
  mainFormChange: (
    field: string,
    value: any,
    shouldValidate?: boolean | undefined
  ) => void;
  formName: string;
  periods: string[];
  projectDates: [string, string];
  disabled?: boolean;
  originalLocation: any;
  disableButtons: boolean;
  unit: {
    ar: string;
    "en-gb": string;
  };
  subkpiData?: any;
  allSubKPIs?: any;
  topElements?: any;
  model2030?: any;
  selectedGESymbol?: string;
  GovernmentEntities?: any;
  role?: string;
};

const SubInfo = React.forwardRef((props: Props, ref) => {
  const params = new URLSearchParams(window.location.search);

  const [openForm, setOpenForm] = useState(
    !(params.get("id") || params.get("wf"))
  );
  const [editFormIndex, setEditFormIndex] = useState<undefined | number>(
    undefined
  );

  const { mainFormChange, GovernmentEntities } = props;
  const classes = useFormStyles();
  const buttonClasses = useButtonStyles();

  const addNewToList = (item: any) => {
    const newList =
      editFormIndex !== undefined
        ? props.currentList.map((cur: any, ind: number) =>
            ind === editFormIndex ? { ...item, status: "modify" } : cur
          )
        : [...props.currentList, item];
    mainFormChange(props.formName, newList);
    setOpenForm(false);
    setEditFormIndex(undefined);
  };

  const lang = conf.getLanguages();

  return (
    <div>
      <div
        style={{
          display: "flex",
          marginTop: "16px",
        }}
      >
        <h1 className={classes.formTitle}>{t(props.formName)}</h1>
        <div>
          <Button
            className={clsx(buttonClasses.button, buttonClasses.submitButton)}
            onClick={() => setOpenForm(true)}
            disabled={props.disabled}
          >
            {" "}
            + {t(`Add Milestone`)}
          </Button>
        </div>
      </div>
      {(openForm || editFormIndex !== undefined) && (
        <SubItemForm
          name={props.formName.slice(0, -1)}
          isMileStone={props.isMilestone}
          save={addNewToList}
          close={() => {
            setOpenForm(false);
            setEditFormIndex(undefined);
          }}
          headers={props.periods}
          initialValues={
            editFormIndex !== undefined
              ? props.currentList[editFormIndex]
              : props.isMilestone
              ? {
                  milestoneValues: [],
                  values: {},
                  basicInformation: {
                    [lang[0]]: {
                      "Project Name": "",
                      "Milestone Description": "",
                    },
                    [lang[1]]: {
                      "Project Name": "",
                      "Milestone Description": "",
                    },
                  },
                  "Milestone planned start date": "",
                  "Milestone planned end date": "",
                  "Milestone weight": "",
                }
              : {}
          }
          editing={editFormIndex !== undefined}
          subkpiData={props.subkpiData}
          allSubKPIs={props.allSubKPIs}
          topElements={props.topElements}
          currentMeaIds={props.currentList
            .filter((item: any) => !!item.meaId)
            .map((item: any) => item.meaId)}
          currentSymbols={undefined}
          selectedEditSymbol={
            editFormIndex !== undefined
              ? props.currentList[editFormIndex].symbol || ""
              : ""
          }
          {...props}
          ref={ref}
          role={props.role}
        />
      )}
      <SubInfoList
        currentList={props.currentList}
        headers={props.periods}
        setField={props.mainFormChange}
        openForm={openForm}
        editForm={setEditFormIndex}
        formName={props.formName}
        disableButtons={props.disableButtons}
        isMileStone={props.isMilestone}
        projectDates={[props.projectDates[0], props.projectDates[1]]}
        unit={props.unit}
        setOpenForm={() => {
          setOpenForm(true);
        }}
        selectedGESymbol={props.selectedGESymbol}
        GovernmentEntities={props.subkpiData}
        role={props.role}
      />
    </div>
  );
});
export default SubInfo;
